import { ICardNameWidth } from './types';
import { CARD_NAME_WIDTH_DEFAULT_STATE, CARD_NAME_WIDTH_SESSIONSTORAGE } from './constants';
import { TCardId } from '../../../../../../../../types/types';

export const getCardNameWidth = (
    cardId: TCardId,
): ICardNameWidth => {
    const _data = sessionStorage.getItem(CARD_NAME_WIDTH_SESSIONSTORAGE);
    const data = _data ? JSON.parse(_data) : {};
    return data.cardId === cardId ? data : CARD_NAME_WIDTH_DEFAULT_STATE;
}
